module.exports = __webpack_public_path__ + "img/1@s.6fdae1d7.jpg";